var AgreementsEndpoints;
(function (AgreementsEndpoints) {
    AgreementsEndpoints["AcknowledgeAgreement"] = "/agreements/acknowledge-agreement";
    AgreementsEndpoints["GetAgreementsToAcknowledge"] = "/agreements/get-agreements-to-acknowledge";
    AgreementsEndpoints["GetApplicationAgreements"] = "/agreements/get-application-agreements";
    AgreementsEndpoints["GetStaticDisclosures"] = "/agreements/get-static-disclosures";
    AgreementsEndpoints["GetPresignedAttachmentUrl"] = "/agreements/get-presigned-attachment-url";
})(AgreementsEndpoints || (AgreementsEndpoints = {}));
var AgreementKey;
(function (AgreementKey) {
    AgreementKey["Schumer"] = "SCHUMER";
    AgreementKey["CardholderAgreement"] = "CARDHOLDER_AGREEMENT";
    AgreementKey["CreditReportAuthorization"] = "CREDIT_REPORT_AUTHORIZATION";
    AgreementKey["DepositAccountAgreement"] = "DEPOSIT_ACCOUNT_AGREEMENT";
    AgreementKey["Esign"] = "ESIGN";
    /** Telephone Consumer Protection Act Notice */
    AgreementKey["TCPA"] = "TCPA";
    AgreementKey["TermsOfService"] = "TERMS_OF_SERVICE";
    AgreementKey["RewardsTerms"] = "REWARDS_TERMS";
    AgreementKey["PrivacyNotice"] = "PRIVACY_NOTICE";
})(AgreementKey || (AgreementKey = {}));
var NoticeKey;
(function (NoticeKey) {
    NoticeKey["InformationSharing"] = "INFORMATION_SHARING";
    NoticeKey["ImportantTerms"] = "IMPORTANT_TERMS";
})(NoticeKey || (NoticeKey = {}));
const RATES_AND_FEES_PREMIUMS = [
    'default', // no-fee
    'premium', // legacy $99
    'bilt_blue',
    'bilt_obsidian',
    'bilt_palladium',
    'bilt_blue_conversion',
    'bilt_obsidian_conversion',
    'bilt_palladium_conversion',
    'coinbase',
    'premium-79',
    'premium-99',
    'premium-99-qatar',
    'premium-99-avianca',
    'premium-199-alibaba',
    'premium-249-avianca',
    'premium-499-qatar',
    'premium-99-avelo',
];
const getPremiumFromAgreementUrl = (pdfUrl = '') => {
    const matches = pdfUrl.match(/schumer\/(.+?)\//);
    const premium = (matches === null || matches === void 0 ? void 0 : matches.length)
        ? matches[1]
        : undefined;
    return premium;
};
const getNumberFromPremium = (premium) => {
    let stringAsNumber;
    switch (premium) {
        case 'bilt_blue':
        case 'bilt_blue_conversion':
        case 'coinbase':
        case 'default':
            return 0;
        case 'premium':
            return 99;
        case 'bilt_obsidian':
        case 'bilt_obsidian_conversion':
            return 95;
        case 'bilt_palladium':
        case 'bilt_palladium_conversion':
            return 495;
        default:
            stringAsNumber = premium
                ? Number(premium === null || premium === void 0 ? void 0 : premium.replace(/^premium-(\d+)(-.+?)?$/, '$1'))
                : 0;
            if (isNaN(stringAsNumber)) {
                throw new Error(`getPremiumAmountFromAgreementUrl invariant violation: unable to parse premium ${premium}`);
            }
            else {
                return stringAsNumber;
            }
    }
};
const getRatesAndFeesPremiumAmountFromAgreementUrl = (pdfUrl = '') => {
    const premium = getPremiumFromAgreementUrl(pdfUrl);
    return getNumberFromPremium(premium);
};
const getRatesAndFeesJsonUrl = ({ env, premium, }) => {
    const hostSuffix = env === 'production' ? '' : '-staging';
    const path = `/schumer/${premium || 'default'}/rates_and_fees.json`;
    const url = `https://legal.cardless${hostSuffix}.com${path}`;
    return url;
};
export { AgreementsEndpoints, AgreementKey, NoticeKey, getPremiumFromAgreementUrl, getRatesAndFeesJsonUrl, getRatesAndFeesPremiumAmountFromAgreementUrl, getNumberFromPremium, RATES_AND_FEES_PREMIUMS, };
